export default __webpack_public_path__ + "static/media/hht2_wordplay.50c64e33.png";